import { useState, useEffect } from "react";
import About from "./About";
import SlideJoin from "./SlideJoin";
import Contact from "./Contact";
import axios from 'axios';
import { G_API } from '../constants/globalVar';
import AllCourses from "./AllCourses";
import AllEvents from "./AllEvents";
import AllBlogs from "./AllBlogs";
import AllSliders from "./AllSliders";
import DefaulHelmet from "./Helmet";
import SelectedArticles from "./SelectedArticles";
import { FaUserGraduate, FaCertificate, FaCrown, FaLayerGroup, FaLaptop, FaBookOpen, FaUsers, FaBrain, FaSchool, FaHandsHelping, FaGlobe, FaHandshake } from "react-icons/fa";
import { HighlightBtn } from "./Button/HighLightBtn";
import Testimonials from "./Testimonials";
import SearchBar from "./SearchBar";
import PlaceholderSlider from "./Placeholders/PlaceholderSlider";
import PlaceholderPostVertical from "./Placeholders/PlaceholderPostVertical";
import PlaceholderPostHorizontal from "./Placeholders/PlaceholderPostHorizontal";
import PartnerSliders from "./Carousel/PartnerSlide";

const Home = () => {
    const [latestCourses, setLatestCourses] = useState([]);
    const [latestBlogs, setLatestBlogs] = useState([]);
    const [latestEvents, setLatestEvents] = useState([]);
    const [sliders, setSlider] = useState([]);
    const [partners, setPartners] = useState([]);
    const [featurePosts, setFeaturePosts] = useState([]);
    const [featureLinks, setFeatureLinks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: G_API+'home',
        };

        axios(config)
        .then((response) => {
            const items = response.data.DATAS;
            setLatestCourses(items.latestCourses);
            setLatestBlogs(items.latestBlogs);
            setLatestEvents(items.latestEvents);
            setSlider(items.sliders);
            setPartners(items.partners);
            setFeaturePosts(items.featurePosts?.slice(0,3) || []);
            setFeatureLinks(items.featureLinks?.slice(0,3) || []);
            setIsLoading(false);
        })
        .catch(function (error) {
            console.error(error);
        });
    },[]);

    const isBlog = item => item?.author && item?.content;
    const isDepartment = item => item?.department && item?.paragraph1;

    return (
        <>
            <DefaulHelmet
                title={'Home'}
                />
            <div>
                <section id="sliders">
                <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
                    {isLoading ? (
                        <PlaceholderSlider />
                    ) : (
                    <div className="carousel-inner">
                        {sliders.map((item, index) => (
                            <AllSliders key={item.id} item={item} active={index === 0 ? "active" : ""} />
                        ))}
                    </div>
                    )}
                    <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel"
                        data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#header-carousel"
                        data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
                </section>
            </div>
            <About/>
            <div className="d-flex justify-content-center">
                <SearchBar placeholder="Course name, keywords..." />
            </div>


            {featurePosts.length > 0 && (
                <section id="selected-articles" className="bg-light py-5">
                    <div className="container-xxl my-5 py-5">
                        <div className="container py-5">
                            <div className="text-center mx-auto mb-5" data-wow-delay="0.1s" >
                                <h2 className="mb-1">A non-profit higher education institution from Ah Nyar</h2>
                            </div>
                            <div>
                                {isLoading ? (
                                    <PlaceholderPostHorizontal />
                                ) : (
                                    <div className="row">
                                        {featurePosts.map((item, index) => {
                                            if (!item) return null;

                                            const componentItem = isBlog(item)
                                                ? item
                                                : isDepartment(item)
                                                ? {
                                                    title: item.title,
                                                    description: item.paragraph1,
                                                    feature_img: { src: item?.image1 },
                                                    updated_at: item?.updated_at,
                                                    id: item?._id,
                                                    is_department: true,
                                                }
                                                : null;

                                            return componentItem ? (
                                                <div className="col-md-4 col-12" key={index}>
                                                    <SelectedArticles item={componentItem} />
                                                </div>
                                            ) : null;
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <section>
                <div className="container-xxl py-5">
                    <div className="container py-5">
                    <div
                        className="text-center mx-auto mb-5 wow fadeInUp"
                        data-wow-delay="0.1s"
                        style={{ maxWidth: '500px' }}
                    >
                        <h1 className="display-6 mb-1">Our Highlights</h1>
                        <p className="mb-5">We offer non-profit courses and research insights</p>
                    </div>

                    <div className="row text-start">
                        <div className="col-12 col-md-4">
                            <HighlightBtn icon={FaBookOpen} text="3 Diploma courses" />
                            <HighlightBtn icon={FaCertificate} text="20 Certificate courses" />
                            <HighlightBtn icon={FaCrown} text="1 Scholarship and Education Advisory Programme" />
                            <HighlightBtn icon={FaLayerGroup} text="1 Scholarship Scheme" />
                        </div>
                        <div className="col-12 col-md-4">
                            <HighlightBtn icon={FaUserGraduate} text="310 Graduates" />
                            <HighlightBtn icon={FaUsers} text="132 Current Students" />
                            <HighlightBtn icon={FaLaptop} text="1 Online library" />
                            <HighlightBtn icon={FaBrain} text="1 Research Hub" />
                        </div>
                        <div className="col-12 col-md-4">
                            <HighlightBtn icon={FaSchool} text="2 Community Learning Hubs" />
                            <HighlightBtn icon={FaHandsHelping} text="20+ Community Projects" />
                            <HighlightBtn icon={FaGlobe} text="10+ International Partners" />
                            <HighlightBtn icon={FaHandshake} text="10+ Local Partners" />
                        </div>
                    </div>
                    </div>
                </div>
            </section>

            { partners.length > 0 && (
                <section id="partner-slider">
                    <div id="partner-header-carousel" className="carousel slide" data-bs-ride="carousel">
                        <div
                            className="text-center mx-auto mb-5 wow fadeInUp"
                            data-wow-delay="0.1s"
                            style={{ maxWidth: '500px' }}
                        >
                            <h1 className="display-6 mb-1">Our Partners</h1>
                            <p className="mb-5">Proudly partnering with organizations committed to excellence and innovation for mutual growth and shared success.</p>
                        </div>
                        {isLoading ? (
                            <PlaceholderSlider />
                            ) : (
                            <div className="carousel-inner">
                                {partners.map((group, index) => (
                                <PartnerSliders
                                    key={index}
                                    items={group}
                                    active={index === 0 ? "active" : ""}
                                />
                                ))}
                            </div>
                        )}
                        <button className="carousel-control-prev" type="button" data-bs-target="#partner-header-carousel" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#partner-header-carousel" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </section>
            )}

            <section id="community" className="bg-warm py-5">
                <div className="container-xxl py-5">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                                <div className="h-100">
                                    <h1 className="display-6 mb-5">A Community That Supports You</h1>
                                    <p className="mb-5">We exist to serve students from marginalised and under-served backgrounds.</p>
                                    <ul>
                                        {featureLinks.map((item, index) => {
                                            if (!item) return null;

                                            const item_url = isBlog(item) ? `/blogs/${item.id}` : `departments-articles/${item._id}`;

                                            return item_url ? (
                                                <li className="my-2" key={index}><a href={ item_url } target="_blank" rel="noopener noreferrer">{ item.title }</a></li>
                                            ) : null;
                                        })}
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="position-relative overflow-hidden h-100" style={{ minHeight: '400px' }}>
                                    <img className="position-absolute w-100 h-100 ps-5" src="/assets/img9.jpg" alt="" style={{
                                        objectFit: 'cover',
                                        }} />
                                    <img className="position-absolute top-0 start-0 bg-white mt-5 ps-2 p-2" src="/assets/img8.jpg" alt="" style={{ width: '200px', height: '200px', objectFit:'cover'}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Testimonials />
            <hr/>
            { latestCourses.length > 0 && (
                <section id="course">
                    <div className="container-xxl my-5 py-5">
                        <div className="container py-5">
                            <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px'}}>
                                <div className="d-inline-block rounded-pill bg-important text-important py-1 px-3 mb-3">Online Courses</div>
                                <h1 className="display-6 mb-1">Online Courses</h1>
                                <p className="mb-5">Everyone can access all learning courses free</p>
                            </div>
                            <div className="row g-4 justify-content-center list">
                            {isLoading ? (
                                <PlaceholderPostVertical />
                            ) : (
                                <div className="item">
                                    {latestCourses.map(item => (
                                        <AllCourses key={item.id} item={item}  style={{
                                            width: "calc(33.33% - 20px)",
                                            margin: "20px",
                                            textAlign: "center"
                                        }}/>
                                    ))}
                                </div>
                            )}
                            </div>
                        </div>
                    </div>
                </section>
            )}
            <hr/>
            { latestEvents.length > 0 && (
                <section id="event">
                    <div className="container-xxl my-5 py-5">
                        <div className="container py-5">
                        <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px'}}>
                            <div className="d-inline-block rounded-pill bg-important text-important py-1 px-3 mb-3">Events</div>
                            <h1 className="display-6 mb-1">Events</h1>
                            <p className="mb-5">Everyone can access events for free</p>
                        </div>
                            <div className="row g-4 justify-content-center list">
                            {isLoading ? (
                                <PlaceholderPostVertical />
                            ) : (
                                <div className="item">
                                    {latestEvents.map(item => (
                                        <AllEvents key={item.id} item={item}  style={{
                                            width: "calc(33.33% - 20px)",
                                            margin: "20px",
                                            textAlign: "center"
                                        }}/>
                                    ))}
                                </div>
                            )}
                            </div>
                        </div>
                    </div>
                </section>
            )}
            <hr/>
            { latestBlogs.length > 0 && (
                <section id="course">
                    <div className="container-xxl my-5 py-5">
                        <div className="container py-5">
                        <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px'}}>
                            <div className="d-inline-block rounded-pill bg-important text-important py-1 px-3 mb-3">Blogs</div>
                            <h1 className="display-6 mb-1">Blogs</h1>
                            <p className="mb-5">Everyone can access all learning courses free</p>
                        </div>
                            <div className="row g-4 justify-content-center list">
                            {isLoading ? (
                                <PlaceholderPostVertical />
                            ) : (
                                <div className="item">
                                    {latestBlogs.map(item => (
                                        <AllBlogs key={item.id} item={item}  style={{
                                            width: "calc(33.33% - 20px)",
                                            margin: "20px",
                                            textAlign: "center"
                                        }}/>
                                    ))}
                                </div>
                            )}
                            </div>
                        </div>
                    </div>
                </section>
            )}
            <hr/>
            <SlideJoin/>
            <Contact/>
        </>
    )
}
export default Home;
